import { PROFILES } from '../CONST';

export const CIERRE_DIARIO_WRITE = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
];
export const CIERRE_DIARIO_READ = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.comercialGarantia,
  PROFILES.gerenteGarantia,
  PROFILES.suscripcionGarantia,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
  PROFILES.riesgoOperacional,
  PROFILES.siniestros,
  PROFILES.consultaBasico,
];

export const CIERRE_MENSUAL_WRITE = [PROFILES.ceo, PROFILES.administradorTI, PROFILES.actuariado];
export const CIERRE_MENSUAL_READ = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.siniestros,
];

export const CIERRE_DIARIO_CEO = [PROFILES.ceo, PROFILES.administradorTI,];
export const CIERRE_MENSUAL_CEO = [PROFILES.ceo, PROFILES.administradorTI,];

export const CIERRE_OPERACIONAL_READ = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.comercialGarantia,
  PROFILES.gerenteGarantia,
  PROFILES.suscripcionGarantia,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
  PROFILES.riesgoOperacional,
  PROFILES.siniestros,
  PROFILES.consultaBasico,
];
export const CIERRE_OPERACIONAL_WRITE = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
];

export const CIERRE_OPERACIONAL_CEO = [PROFILES.ceo, PROFILES.administradorTI,];

export const REASEGURO_WRITE = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.actuariado,
]

export const REASEGURO_READ = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
  PROFILES.riesgoCredito,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
  PROFILES.riesgoOperacional,
  PROFILES.siniestros,
]

